// client/src/components/forms/Checkbox.js
//
// Checkbox lives outside the FormField wrapper because its label sits
// INLINE to the right of the box rather than as an uppercase eyebrow
// above. Different layout → own primitive with its own label prop.
//
// Under the hood, a visually-hidden native <input type="checkbox">
// handles keyboard, focus, screen reader announcement, and form
// participation. The visible box is a decorative <span> next to it,
// keyed to the input's state via the `checked` prop.
//
// Check mark is a hand-authored two-stroke SVG path with a small fixed
// tilt (-4°) — the "sitting slightly off-center" personality from §3b.
// Fixed tilt (not random per render) so the mark doesn't jitter to a
// new angle every time it appears.

export function Checkbox({
  label,
  checked,
  onChange,
  disabled = false,
  className = '',
  ...rest
}) {
  return (
    <label
      className={[
        'inline-flex items-center gap-3 select-none',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
        className,
      ].join(' ')}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange?.(e.target.checked)}
        disabled={disabled}
        className="sr-only peer"
        {...rest}
      />

      <span
        className={[
          'relative',
          'w-5 h-5 shrink-0',
          'flex items-center justify-center',
          'rounded border',
          'transition-colors',
          'peer-focus-visible:ring-2 peer-focus-visible:ring-accent peer-focus-visible:ring-offset-2',
          checked
            ? 'bg-accent border-accent'
            : 'bg-paper border-ink',
        ].join(' ')}
        aria-hidden="true"
      >
        {checked && (
          <svg
            viewBox="0 0 20 20"
            width="14"
            height="14"
            style={{ transform: 'rotate(-4deg)' }}
          >
            <path
              d="M 3.5 10.5 L 7.6 14.2 L 15.8 5.2"
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </span>

      <span className="text-base text-ink">{label}</span>
    </label>
  );
}